import styled from 'styled-components'

import H1 from '../../H1'

const Title = styled(H1)`
  margin-bottom: 0;
`

export default Title
